import { createFileRoute } from "@tanstack/react-router";
import { SmsTestCard } from "../components/settings/sms/SmsTestCard";

export const Route = createFileRoute("/_auth/settings/sms")({
  staticData: {
    titleKey: "settings.section.sms",
    breadcrumbKey: "breadcrumb.manage",
    breadcrumbN: 2,
  },
  component: SmsPage,
});

function SmsPage() {
  return <SmsTestCard />;
}
